module.exports = __webpack_public_path__ + "media/21.523b9722.mp3";